// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";

// HELPERS
import {createClassName} from "@helpers/utils";
import fulfillmentCheck from "./Placering.fulfillment";
import Select from "../../../../components/Select/Select";
import Validator from "../../../../classes/Validator";
import EditableField from "../../components/EditableField/EditableField";
import OptionsList from "../../components/OptionsList/OptionsList";
import DefaultFields from "../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../Cob.helpers";
import NumberField from "../../components/NumberField/NumberField";


export default class Placering extends React.PureComponent {
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {props, state} = this;
		const {fields, validFields} = state;
		const {availableBanks} = props;

		/**
		 * Set up the dropdown with selectable banks.
		 */
		let availableBankOptions = [];
		for (const bankName in availableBanks) {
			if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;
			availableBankOptions.push({
				label: bankName,
				value: bankName
			});
		}

		availableBankOptions.push({
			label: "Övriga",
			value: "-"
		});

		let selectedBankIndex = -1;

		if (fields.bank_name && fields.bank_name.length > 0) {
			let bankFoundInList = false;
			for (const bankName in availableBanks) {
				if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) {
					continue;
				}
				selectedBankIndex++;
				if (bankName === fields.bank_name) {
					bankFoundInList = true;
					break;
				}
			}

			if (!bankFoundInList && fields.bank_name === '-') {
				selectedBankIndex++;
			}
		}

		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div style={{alignItems: "flex-start", width: "100%"}}>
					<h2 style={{marginBottom: "0"}}>Engångsinsättning / Månadssparande</h2>

					<p>
						Du kan i samband med att kontot öppnas även välja att påbörja ett sparande i någon av våra
						fonder, antingen genom en engångsinsättning eller genom ett regelbundet månadssparande.
					</p>

					<FieldsCollection
						fields={[
							{
								render: (
									<OptionsList
										type="radio"
										orientation="horizontal"
										name="radio_fund_spets"
										description="Jag vill börja spara i aktiefonden Spets"
										options={fields.radio_fund_spets.options}
										onChange={this._onChangeRadio}
									/>
								),
							},
						]}
					/>

					{fields.radio_fund_spets.options[1].checked && (
						<div className={"fund-choice"}>
							<p style={{width: "100%", margin: "0 0 15px 0"}}>
								Ange belopp för engångsinsättning och/eller månadssparande.
							</p>

							<div className={"column"}>
								<h4>Engångsinsättning</h4>
								<EditableField
									Component={NumberField}
									name="onetime_save"
									label="Ange"
									value={state.fields.onetime_save}
									valid={(state.fields.onetime_save >= 1000 || (state.fields.onetime_save === '' && state.fields.monthly_save >= 500))}
									onChange={this._onFieldChange}
									onBlur={this._onFieldBlur}
									unit={"kr"}
									style={{maxWidth: "150px"}}
								/>
								<p>Minsta belopp 1 000 kr.</p>
							</div>
							<div className={"column"}>
								<h4>Månadssparande</h4>
								<EditableField
									Component={NumberField}
									name="monthly_save"
									label="Ange"
									value={state.fields.monthly_save}
									valid={(state.fields.monthly_save >= 500 || (state.fields.monthly_save === '' && state.fields.onetime_save >= 1000))}
									onChange={this._onFieldChange}
									onBlur={this._onFieldBlur}
									unit={"kr"}
									style={{maxWidth: "150px"}}
								/>
								<p>Minsta belopp 500 kr.</p>
							</div>

							<input type="hidden" name="product_name" value="Spets A (SE0013409463)"/>
							<input type="hidden" name="documents" value="https://assets.fairinvestments.se/KIID-Spets-A.pdf"/>
						</div>
					)}

					<h3 style={{
						width: "100%",
						margin: "30px 0 0 0",
						borderTop: "1px solid #EEE",
						paddingTop: "40px"
					}}>
						Autogiromedgivande
					</h3>

					<div className="description">
						<p>
							Undertecknad (”betalaren”), medger att betalning får göras genom uttag från angivet konto
							eller
							av betalaren senare angivet Konto, på begäran av angiven betalningsmottagare för betalning
							till
							denne på viss dag (”förfallodagen”) via Autogiro. Betalaren medger att insättning och uttag
							från
							angivet konto eller av betalaren föranmält konto får göras på begäran av betalaren.
							Betalaren
							samtycker till att behandling av personuppgifter som lämnats i detta medgivande behandlas av
							betalarens betaltjänstleverantör, betalningsmottagaren, betalningsmottagarens
							betaltjänstleverantör och Bankgirocentralen BGC AB för administration av tjänsten.
							Personuppgiftsansvariga för denna personuppgiftsbehandling är betalarens
							betaltjänstleverantör,
							betalningsmottagaren samt betalningsmottagarens betaltjänstleverantör. Betalaren kan när som
							helst begära att få tillgång till eller rättelse av personuppgifterna genom att kontakta
							betalarens betaltjänstleverantör. Ytterligare information om behandling av personuppgifter i
							samband med betalningar kan finnas i villkoren för kontot och i avtalet med
							betalningsmottagaren. Betalaren kan när som helst återkalla sitt samtycke, vilket medför att
							tjänsten i sin helhet avslutas.
						</p>
					</div>

					<FieldsCollection
						fields={[
							{
								render: (
									<OptionsList
										type="radio"
										orientation="horizontal"
										name="radio_customer_autopay"
										description="Jag ger mitt medgivande till betalning via autogiro"
										options={fields.radio_customer_autopay.options}
										onChange={this._onChangeRadio}
									/>
								),
							},
						]}
					/>

					{!!fields.radio_customer_autopay.options[1].checked && (
						<React.Fragment>
							<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
								<Select
									name="bank_name"
									label="Bank"
									style={{width: "45%", marginRight: "10px"}}
									selectedIndex={selectedBankIndex}
									options={availableBankOptions}
									onChange={this._onSelectBankChange}
								/>


								{fields.bank_name === '-' && (
									<React.Fragment>
										<EditableField
											name="bank_name_custom"
											label="Bank"
											style={{width: "45%"}}
											value={fields.bank_name_custom || ""}
											valid={validFields.bank_name_custom}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
										/>
										<input type="hidden" name="bank_name"
											   value={fields.bank_name_custom}/>
									</React.Fragment>
								)}

								{fields.bank_name !== '-' && (
									<input type="hidden" name="bank_name_custom" value=""/>
								)}
							</div>

							{fields.bank_name === 'Swedbank' && (
								<p style={{
									background: "#FFFFD5",
									padding: "10px",
									fontSize: "12px",
									margin: "10px 0",
									maxWidth: "600px"
								}}>
									Det förekommer att Swedbank har en femte siffra i clearingnumret. Vänligen ange
									enbart de fyra första innan bindestrecket. Exempel: 8214-9 ska anges som 8214.
								</p>
							)}

							<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
								<EditableField
									name="claering_nr"
									style={{width: "45%", marginRight: "10px"}}
									label="Clearingnummer"
									value={fields.claering_nr || ""}
									valid={validFields.claering_nr}
									onChange={this._onClearingFieldChange}
									onBlur={this._onFieldBlur}
								/>
								<EditableField
									name="account_number"
									style={{width: "45%"}}
									label="Kontonummer"
									value={fields.account_number || ""}
									valid={validFields.account_number}
									onChange={this._onAccountFieldChange}
									onBlur={this._onFieldBlur}
								/>
								<input type="hidden" name="customer_account_clearing_no"
									   value={fields.claering_nr || ""}/>
							</div>
						</React.Fragment>
					)}

					{!!fields.radio_customer_autopay.options[0].checked && (
						<div style={{
							display: "block",
							padding: "15px",
							background: "#EEE",
							margin: "20px 0 0 0",
							lineHeight: "20px"
						}}>
							<strong style={{display: "block"}}>Insättning</strong>
							För att sätta in pengar använder du BG 5498-3614, mottagare Fair Investments Sweden AB, ange
							ditt depånummer som referens.

							Depånummer tillsammans med en kopia på insättningsinstruktioner kommer att skickas till dig
							efter att avtalet signerats.
						</div>
					)}
				</div>
			</div>
		);
	}

	_onChangeRadio = ({type, name}, option, index) => {
		name = name || option.name;
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});


		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));
	};

	_onSelectBankChange = (option) => {
		this._onFieldChange.call(this, "bank_name", option.value);
	};

	_onClearingFieldChange = (name, value) => {
		// Remove all non-numbers
		value = value.replace(/[^0-9]+/g, "");

		// Limit clearing numbers to 4 numbers, we'll show a message that says to enter only first four for the
		// banks with longer numbers
		if (value.length >= 4) {
			value = value.substring(0, 4);
		}

		let valid = (this.state.fields.bank_name === '-') ? true :
			Validator.validateClearingNumber(value, this.state.fields.bank_name, this.props.availableBanks);

		this._onFieldChange.call(this, name, value, valid);
	};

	_onAccountFieldChange = (name, value) => {
		// Remove dashes
		value = value.replace("-", "");
		this._onFieldChange.call(this, name, value, value.length > 0);
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_fieldValidator = (name, value) => {
		if (name === 'account_number') {
			return this._isValidBankAccountNo(false, value, this.state.fields.claering_nr);
		}
		return value.length > 0;
	};

	_onFieldBlur = (name) => {
		if (name === 'customer_account_bank_clearingno') {
			CobHelpers.onViewFieldBlur.call(this, name, null, true);
		}
		else {
			CobHelpers.onViewFieldBlur.call(this, name);
		}
	};

	_isValidBankAccountNo(doAdvancedValidation, accountNumber, clearingNumber) {
		if (accountNumber.length === 0) {
			return false;
		}

		if (doAdvancedValidation) {
			let bankNoToValidate = clearingNumber + ", " + accountNumber;
			let kontonummer = window.kontonummer(bankNoToValidate);
			return kontonummer !== false;
		}

		const replacedValue = accountNumber.split(" ").join("");
		return replacedValue.length > 5 && !isNaN(replacedValue);
	}
}


// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"radio_customer_autopay",
		"account_number",
		"claering_nr",
		"bank_name",
		"bank_name_custom",

		"onetime_save",
		"onetime_save_1",
		"onetime_save_2",
		"onetime_save_3",
		"onetime_save_4",
		"onetime_save_5",

		"monthly_save",
		"monthly_save_1",
		"monthly_save_2",
		"monthly_save_3",
		"monthly_save_4",
		"monthly_save_5",
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};
	return {
		validFields: [],
		fields: {
			"account_number": "",
			"claering_nr": "",
			"bank_name": "",
			"bank_name_custom": "",

			"radio_fund_spets": {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},
			"radio_customer_autopay": {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},

			"onetime_save": "",
			"monthly_save": "",

			"onetime_save_1": "",
			"monthly_save_1": "",

			"onetime_save_2": "",
			"monthly_save_2": "",

			"onetime_save_3": "",
			"monthly_save_3": "",

			"onetime_save_4": "",
			"monthly_save_4": "",

			"onetime_save_5": "",
			"monthly_save_5": "",
		},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Placering.js